import script from "./AppProfileCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppProfileCard.vue?vue&type=script&setup=true&lang=ts"

import "./AppProfileCard.vue?vue&type=style&index=0&id=433d3605&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-433d3605"]])

export default __exports__